import Vue from 'vue';
import MuseUI from 'muse-ui';
import 'muse-ui/dist/muse-ui.css';
import axios from 'axios';
import { dateFilter } from "vue-date-fns";

import App from './App.vue'

Vue.config.productionTip = false
Vue.use(MuseUI);
Vue.prototype.$http = axios;
Vue.filter("date", dateFilter);

new Vue({
  el: '#app',
  render: h => h(App)
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js